export enum CreditStatus {
  Qualifying = 'qualifying',
  ActionRequired = 'actionRequired',
  PurchaseOnly = 'purchaseOnly',
}

export enum CreditScoreKey {
  TransUnionSoft = 'transUnionSoftCreditScore',
  TriMergeSoft = 'softTriMergeScore',
  HardPull = 'hardPullScore',
}

export enum CreditValidationKey {
  TransUnionSoftPull = 'transUnionSoftPull',
  TriMergeSoftPull = 'triMergeSoftPull',
  HardPull = 'hardPull',
}

export enum CreditFocusSection {
  SoftPull = 'soft-pull',
  SoftTriMerge = 'soft-tri-merge',
  HardPull = 'hard-pull',
}

export interface CreditValidationResult {
  isValid: boolean
  message: string
  canOverride: boolean
  status: CreditStatus
}

export interface CreditValidationResults {
  [CreditValidationKey.TransUnionSoftPull]: CreditValidationResult
  [CreditValidationKey.TriMergeSoftPull]: CreditValidationResult
  [CreditValidationKey.HardPull]: CreditValidationResult
}

export interface ValidationOptions {
  canOverrideCredit: boolean
  hasCoBorrower: boolean
  isPurchase: boolean
}

export const CREDIT_TYPE_MAPPINGS = [
  {
    key: CreditValidationKey.TransUnionSoftPull,
    section: CreditFocusSection.SoftPull,
  },
  {
    key: CreditValidationKey.TriMergeSoftPull,
    section: CreditFocusSection.SoftTriMerge,
  },
  {
    key: CreditValidationKey.HardPull,
    section: CreditFocusSection.HardPull,
  },
] as const
